module.exports = __webpack_public_path__ + "static/media/pinaza_12.8a1d6205.jpeg";